import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AConcreteResource } from '../../../../AConcreteResource';
import { ApiInterfaceModel } from '../../../../../models/resources/api-interface.model';
import { Router } from '@angular/router';
import { ApiInterfaceService } from '../../../../../services/resources/api-interface.service';
import { ApiInterfaceCustomerService } from '../../../../../services/resources/api-interface-customer.service';
import { MdbButtonComponent } from '../../../../utils/mdb-button/mdb-button.component';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { CustomNotificationService } from '../../../../../services/utils/custom-notification.service';
import { HttpErrorsService } from '../../../../../services/utils/http-errors.service';
import {
  ApiInterfaceCustomerTableComponent
} from './api-interface-customer-table/api-interface-customer-table.component';
import {
  NewApiInterfaceCustomerModalComponent
} from './new-api-interface-customer-modal/new-api-interface-customer-modal.component';

@Component({
  selector: 'app-api-interface-customers',
  imports: [
    MdbButtonComponent,
    ApiInterfaceCustomerTableComponent
  ],
  templateUrl: './api-interface-customers.component.html',
  styleUrl: './api-interface-customers.component.scss',
})
export class ApiInterfaceCustomersComponent extends AConcreteResource<ApiInterfaceModel> {
  syncLoading = false;

  constructor(
    router: Router,
    private apiInterfaceService: ApiInterfaceService,
    public apiInterfaceCustomerService: ApiInterfaceCustomerService,
    private modalService: MdbModalService,
    private notificationService: CustomNotificationService,
    private httpErrorsService: HttpErrorsService,
    private translate: TranslateService
  ) {
    super(router, apiInterfaceService);
  }

  openNewModal() {
    const modalRef = this.modalService.open(NewApiInterfaceCustomerModalComponent, {
      ignoreBackdropClick: true,
      data: {
        apiInterface: this.model()
      }
    });
    modalRef.onClose.subscribe((apiInterface) => {
      if (!apiInterface)
        return;
      this.notificationService.success('API_INTERFACES.CUSTOMER_SUCCESSFULLY_ADDED');
    });
  }

  syncCustomers() {
    const apiInterface = this.model();
    if (!apiInterface?.id)
      return;
    this.syncLoading = true;
    this.apiInterfaceService
      .syncCustomers(apiInterface.id)
      .pipe(finalize(() => (this.syncLoading = false)))
      .subscribe({
        next: (res) => {
          const message = this.translate.instant('API_INTERFACES.SYNC_CUSTOMERS_DONE', { count: res.imported });
          this.notificationService.success(message);
          this.apiInterfaceCustomerService.getAll({ resetData: true });
        },
        error: (err) => this.httpErrorsService.handleError(err),
      });
  }
}
